import { render, staticRenderFns } from "./GrayBarPoisNumber.vue?vue&type=template&id=87b592ee&"
import script from "./GrayBarPoisNumber.vue?vue&type=script&lang=js&"
export * from "./GrayBarPoisNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports